import { Row } from "@tanstack/react-table";
import { Schedule2 } from "../../../../../../../services/cloudchipr.api";
import { getCronFrequency } from "../../../../common/utils/helpers/cron/getCronFrequency";

export const scheduledJobsFrequencyFilter = (
  row: Row<Schedule2>,
  _: string,
  keyword: string,
) => {
  const cron = row.original.cron;
  const frequency = getCronFrequency(cron).toLowerCase();

  return frequency.includes(keyword.toLowerCase().trim());
};
